import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { useForm, useFormContext } from "react-hook-form";
import { Tooltip } from "@mui/material";
import { useEMRGeneralContext } from "../newGeneralEmr/EMRContextGeneral";
import InputArea from "../../../common/components/FormFields/InputArea";
import ANCPlan from "../gynacemr/ANCPlan";
import GyancInstruction from "../gynacemr/GyancInstruction";

export default function Advice(props) {
  const { adviceData, setAdviceData, fields, setFields } = props;
  const [allAdviceChipsList, setAllAdviceChipsList] = useState([]);
  const [adviceChipsList, setAdviceChipsList] = useState([]);
  const [chipsCount, setChipsCount] = useState(5);
  const [checkDuplicate, setCheckDuplicate] = useState(false);
  const [selectedChips, setSelectedChips] = useState([]);
  const [selectedAdvice, setSelectedAdvice] = useState(null);
  const [openAdviceModal, setOpenAdviceModal] = useState(false);
  const [data, setData] = useState([]);
  const [edit, setEdit] = useState(false);
  const [row, setRow] = useState();
  const [index, setIndex] = useState();
  const [editOpen, setEditOpen] = useState(false);
  const [save, setSave] = useState(false);

  // Function to handle checkbox state change
  const handleCheckboxChange = (index) => {
    setFields((prevFields) => {
      const updatedFields = [...prevFields];
      updatedFields[index].checked = !updatedFields[index].checked;
      return updatedFields;
    });
  };

  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
    register,
    setValue,
  } = useFormContext({});

  useEffect(() => {
    // if (save === true) {
    setAdviceData(data);
    // setSave(false)
    // }
  }, []);
  return (
    <div>
      <div className="flex justify-between bg-rose-200 rounded-t-md">
        <p className="text-sm font-semibold pl-2 py-1">Advice</p>
        <div className="flex my-auto"></div>
      </div>
      <div
        className={`${
          props.from === "dental" || props.from === "generalEMR"
            ? "max-h-44 min-h-24"
            : props.from === "cardiology"
            ? "max-h-44 min-h-24"
            : props.from === "gync"
            ? "max-h-44 min-h-24"
            : props.anc === true
            ? "max-h-44 min-h-24"
            : props.from === "Orthopedic"
            ? "max-h-44 min-h-24"
            : "max-h-24 min-h-24"
        } p-2 overflow-auto  border pb-2 border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md`}
      >
        <div className="flex flex-wrap gap-2">
          {fields.map((field, index) => (
            <div>
              <div key={index} className=" flex gap-4">
                <div className="flex gap-2">
                  <fieldset
                    className="w-full flex gap-2"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                      }
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={field.checked}
                      className="w-[16px] h-[16px] rounded-md"
                      onChange={() => handleCheckboxChange(index)}
                    />
                    <div className="-mt-[3px] text-[16px]">{field.label}</div>
                  </fieldset>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-3">
          <InputArea name="adviceDescription" label="Description" />
        </div>
        {props.anc === true && (
          <>
            <div className="my-2">
              {/* <OPDSurgery
                          pastData={null}
                          surgeryData={surgeryData}
                          setSurgeryData={setSurgeryData}
                          dataSurgery={dataSurgery}
                          setDataSurgery={setDataSurgery}
                          patientVisitedDepartmentId={props.patientVisitedDepartmentId}
                        /> */}
              <ANCPlan />
            </div>

            {/* <div className="mb-1">
              <GyancInstruction
                // instractionDataResult={instractionDataResult}
                // setInstractionDataResult={setInstractionDataResult}
                // instraction={instraction}
                // setInstraction={setInstraction}
                // dataInstruction={dataInstruction}
                // setDataInstruction={setDataInstruction}
                // doctorId={userRole?.employeeId}
                // patientVisitedDepartmentId={props.patientVisitedDepartmentId}
                // markFavoriteData={markFavoriteData}
                pastData={null}
              />
            </div> */}
          </>
        )}
      </div>
    </div>
  );
}

